import { ToastStack, useToastQueue } from '@src/layout/toastQueue';

/** Listings transient toasts for the M6 copy/mark-listed flow. Now a thin
 * adapter over the shared toast queue (#365 dedup) — the bespoke copy that used
 * to live here is gone. Duration (2600ms) and the icon-less danger styling are
 * preserved here so appearance/timing match the original local toaster. */
function useToasts() {
  return useToastQueue(2600);
}


function Toaster({ toasts }) {
  return <ToastStack zIndexClassName="z-[60]" toasts={toasts} dangerIcon={false} />;
}

Toaster.displayName = 'Toaster';
export { Toaster, useToasts };
